import { render } from "./barchart.vue?vue&type=template&id=7b0f284d"
import script from "./barchart.vue?vue&type=script&lang=js"
export * from "./barchart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__